import React from 'react';
import '../../component/membership/membership_page.css'
import '../../component/membership/membership_page_section3.css'
import '../../component/membership/membership_page_section4.css'
import infoIcon from "../../parm_assets/tree_icons.png";

import icon1 from '../../parm_assets/membership/image_12.png';
import icon2 from '../../parm_assets/membership/image_11.png';
import icon3 from '../../parm_assets/membership/image_13.png';
import icon4 from '../../parm_assets/membership/image_14.png';
import icon5 from '../../parm_assets/membership/image_15.png';
import icon6 from '../../parm_assets/membership/image_16.png';

import benefit1 from '../../parm_assets/membership/benefit_1.png';
import benefit2 from '../../parm_assets/membership/benefit_2.png';
import benefit3 from '../../parm_assets/membership/benefit_3.png';
import benefit4 from '../../parm_assets/membership/benefit_4.png';
import benefit5 from '../../parm_assets/membership/benefit_5.png';
import benefit6 from '../../parm_assets/membership/benefit_6.png';
import benefit7 from '../../parm_assets/membership/benefit_7.png';
import benefit8 from '../../parm_assets/membership/benefit_8.png';
import benefit9 from '../../parm_assets/membership/benefit_9.png';

const MembershipPage = () => {

    const purposes = [
    {
      title: "Advancing Arboriculture Knowledge",
      description: "Promote and expand arboriculture knowledge in Malaysia, raising awareness about tree care and green spaces.",
      icon: icon1, // Replace with your SVG icons
    },
    {
      title: "Enhancing Professionalism",
      description: "Enhance arboriculture standards and position Malaysia as a tropical arboriculture hub.",
      icon: icon2,
    },
    {
      title: "Arborist Certification",
      description: "Establish an arborist certification scheme in Malaysia to ensure members' competence and qualifications.",
      icon: icon3,
    },
    {
      title: "Arboriculture Education",
      description: "Incorporate arboriculture knowledge into education at all levels to build a knowledgeable and skilled society.",
      icon: icon4,
    },
    {
      title: "Garden Nation Aspiration",
      description: "Support Malaysia's aspiration to become the Most Beautiful Garden Nation by strengthening green conservation efforts.",
      icon: icon5,
    },
    {
      title: "Tree Conservation Issues",
      description: "Mobilize resources and expertise to uphold the truth regarding tree care, conservation, and preservation.",
      icon: icon6,
    },
  ];

  const benefits = [
    {
      title: "Professional Network",
      desc: "Connect with a national organization of arboriculture professionals in Malaysia.",
      img: benefit1, // Replace with your image paths
    },
    {
      title: "Membership Recognition",
      desc: "Receive a membership card and certificate on yearly renewal.",
      img: benefit2,
    },
    {
      title: "AGM Participation",
      desc: "Attend and participate in PArM's Annual General Meetings (AGM).",
      img: benefit3,
    },
    {
      title: "Voting Rights",
      desc: "Take part in the voting process during the AGM.",
      img: benefit4,
    },
    {
      title: "Access to Knowledge",
      desc: "Gain access to the latest technical knowledge and information on arboriculture.",
      img: benefit5,
    },
    {
      title: "Training Opportunities",
      desc: "Participate in workshops, seminars, and conferences at special member rates.",
      img: benefit6,
    },
    {
      title: "Exclusive Resources",
      desc: "Access exclusive materials from PArM events and web-based services in the member's zone.",
      img: benefit7,
    },
    {
      title: "Development Participation",
      desc: "By invitation, take part in the development of arboriculture standards and guidelines.",
      img: benefit8,
    },
    {
      title: "Discounts",
      desc: "Purchase PArM merchandise and educational materials at special member rates.",
      img: benefit9,
    }
  ];

  const categories = [
    {
      title: "Professional Member",
      price: "100",
      period: "/yr",
      features: [
        "Registration Fee RM50",
        "Open to individuals in the arboriculture field.",
        "Applicants must have at least 5 years of experience in arboriculture or a related field.",
        "Welcomes professionals with a background in arboriculture or similar disciplines."
      ],
    },
    {
      title: "Ordinary Member",
      price: "100",
      period: "/yr",
      features: [
        "Registration Fee RM50",
        "Individuals who are interested in tree management"
      ],
    },
    {
      title: "Corporate Member",
      price: "500",
      period: "/yr",
      features: [
        "Registration Fee RM50",
        "Open to private commercial firms and organizations with three (3) nominees.",
        "Interested in supporting PArM's goals, vision, and objectives.",
        "Aimed to make contributions to PArM's welfare."
      ],
    },
    {
      title: "Veteran Member",
      price: "25",
      period: "/yr",
      features: [
        "Registration Fee RM50",
        "Open to retired members aged 55 and above.",
        "Must have at least 10 years of professional experience.",
        "Requires a history of good performance and reputation."
      ],
    },
    {
      title: "Lifetime Member",
      price: "1,000",
      period: "/yr",
      features: [
        "Registration Fee RM50",
        "Open to all Ordinary Members.",
        "Requires a one-time lump sum payment of RM1,000.00.",
        "Payment is made once in a lifetime."
      ],
    },
    {
      title: "Student Member",
      price: "25",
      period: "/yr",
      features: [
        "Registration Fee RM10",
        "Open to Full-time students in Arboriculture, forestry, landscape, and related courses.",
        "Studying at least 2 years at a recognized institutions",
      ],
    }
  ];

  return (
    <div className="page-container">

      {/* 2. ABOUT US HERO SECTION */}
      <section className="about-hero-section">
        <div className="about-hero-content">
          <h1 className="about-page-title">Membership</h1>
          <nav className="breadcrumb">
            <span className="breadcrumb-item">Home</span>
            <span className="breadcrumb-separator"> &gt; </span>
            <span className="breadcrumb-item active">Membership</span>
          </nav>
        </div>
      </section>

      <section className="member-purpose-section">
      <div className="member-purpose-container">
        <header className="member-purpose-header">
          <div className="member-purpose-badge">
            <img src={infoIcon} alt="icon" className="tree-icon" /> OUR PURPOSE
          </div>
          <h2 className="member-purpose-main-title">PArM's Purpose</h2>
        </header>

        <div className="member-purpose-grid">
          {purposes.map((item, index) => (
            <div key={index} className="member-purpose-card">
              <div className="member-card-icon">
                <img src= {item.icon} className='member-image-icon' />
                </div>
              <h3 className="member-card-title">{item.title}</h3>
              <p className="member-card-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="member-benefits-section">
      <div className="member-benefits-container">
        <div className="member-benefits-header">
          <p className="member-benefits-label">
            <img src={infoIcon} alt="icon" className="tree-icon" /> 
            PARM MEMBERSHIP</p>
          <h2 className="member-benefits-title">Benefits of Joining PArM's Membership</h2>
        </div>

        <div className="member-benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="member-benefit-card">
              <div className="member-benefit-image-wrapper">
                <img src={benefit.img} alt={benefit.title} className="member-benefit-img" />
              </div>
              <div className="member-benefit-content">
                <h3 className="member-benefit-card-title">{benefit.title}</h3>
                <p className="member-benefit-card-desc">{benefit.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="member-membership-section">
      <div className="member-membership-container">
        <header className="member-membership-header">
          <p className="member-purpose-badge"> 
            <img src={infoIcon} alt="icon" className="tree-icon" />
            MEMBERSHIP CATEGORIES</p>
          <h2 className="member-membership-title">Categories of PArM Membership</h2>
        </header>

        <div className="member-membership-grid">
          {categories.map((item, index) => (
            <div key={index} className="member-pricing-card">
              <div className="member-card-top-accent">
                <h3 className="member-card-category-title">{item.title}</h3>
              </div>
              <div className="member-card-body">
                <div className="member-price-tag">
                  <span className="member-currency">RM</span>
                  <span className="member-amount">{item.price}</span>
                  <span className="member-period">/yr</span>
                </div>
                <hr className="member-divider" />
                <ul className="member-feature-list">
                  {item.features.map((feature, idx) => (
                    <li key={idx} className="member-feature-item">
                      <span className="member-check-mark">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <a href="/membership-registration-parm">
                <button className="member-apply-btn">
                  Apply Now;
                </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>


      </div>

  );
};

export default MembershipPage;